import React from 'react';
import '../../assets/styles/Checkbox.css';

const Checkbox = ({ children, hideLabel = false, className = '', ...inputProps }) => (
  <label className={`tp-check ${className}`.trim()}>
    <input type="checkbox" className="tp-check__input" {...inputProps} />
    <span className="tp-check__box" aria-hidden="true">
      <svg viewBox="0 0 12 10" height="10px" width="12px">
        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
      </svg>
    </span>
    {children && (
      <span className={hideLabel ? 'tp-sr-only' : 'tp-check__label'}>{children}</span>
    )}
  </label>
);

export default Checkbox;
export { Checkbox };
